"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toHTMLDataTags = void 0;
var toHTMLDataTags = function (d) {
    var newObj = {};
    for (var key in d) {
        newObj['data-' + key] = d[key];
    }
    return newObj;
};
exports.toHTMLDataTags = toHTMLDataTags;
//# sourceMappingURL=toHTMLDataTags.js.map